var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMarkerPin = function SvgMarkerPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M11.54 2.034c-1.647.276-2.753 1.875-2.505 3.622.175 1.235 1.062 2.258 2.232 2.576l.091.024v6.136c0 5.172.006 6.158.03 6.281.027.126.372 1.034.47 1.236.06.122.22.122.28 0 .1-.202.445-1.11.47-1.236.026-.123.03-1.11.03-6.281l.001-6.136.09-.024c1.431-.388 2.394-1.81 2.258-3.333-.111-1.252-.844-2.267-1.954-2.707a3 3 0 0 0-1.493-.158m.11.934c-.648.115-1.234.57-1.53 1.192a2.31 2.31 0 0 0 .243 2.396c.399.524.99.82 1.636.82.252 0 .42-.027.67-.112.917-.31 1.535-1.323 1.423-2.335-.026-.236-.14-.667-.17-.647-.01.007-.024.05-.03.098-.039.25-.266.553-.51.677a.916.916 0 0 1-1.106-.199c-.53-.57-.261-1.517.484-1.696l.122-.029-.202-.07a3 3 0 0 0-.34-.094 3 3 0 0 0-.69 0",
    clipRule: "evenodd"
  })));
};
export default SvgMarkerPin;